import React from "react";

/* Service card icons (from source HTML) keyed by slug icon field */
const serviceIcons = {
  livestock: (
    <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 8c0-2 1-3 2-3" /><path d="M19 8c0-2-1-3-2-3" />
      <path d="M5 8c-1.5 0-2 1.5-1 3" /><path d="M19 8c1.5 0 2 1.5 1 3" />
      <path d="M7 5c1 1.5 3 2 5 2s4-.5 5-2" /><ellipse cx="12" cy="14" rx="5" ry="5.5" />
      <path d="M10 14h.01M14 14h.01" /><path d="M10.5 17c1 .8 2 .8 3 0" />
    </svg>
  ),
  lab: (
    <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 3h6" /><path d="M10 3v6l-4.5 8a2 2 0 0 0 1.8 3h9.4a2 2 0 0 0 1.8-3L14 9V3" />
      <path d="M7.5 14h9" /><circle cx="10.5" cy="16.5" r=".6" fill="currentColor" /><circle cx="13.5" cy="18" r=".6" fill="currentColor" />
    </svg>
  ),
  research: (
    <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="10.5" cy="10.5" r="6" /><path d="M15 15l5 5" /><path d="M10.5 7.5v6M7.5 10.5h6" />
    </svg>
  ),
  training: (
    <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 8l9-4 9 4-9 4-9-4z" /><path d="M7 10v4c0 1.2 2.2 2.5 5 2.5s5-1.3 5-2.5v-4" /><path d="M21 8v5" />
    </svg>
  ),
  certification: (
    <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 4h6a1 1 0 0 1 1 1v0h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h1a1 1 0 0 1 1-1z" />
      <path d="M9 4a1 1 0 0 0-1 1h8a1 1 0 0 0-1-1" /><path d="M9 12l1.5 1.5L13 11" /><path d="M16 16H8" />
    </svg>
  ),
  quality: (
    <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 3l7 3v5c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6l7-3z" /><path d="M9 12l2 2 4-4" />
    </svg>
  ),
};

const serviceStroke = {
  livestock: "#f7941d", lab: "#e11d3c", research: "#c0185c",
  training: "#f7941d", certification: "#e11d3c", quality: "#3b9ae1",
};

export const ServiceIcon = ({ name }) => (
  <span style={{ display: "inline-flex", color: serviceStroke[name] || "#e11d3c" }}>
    {React.cloneElement(serviceIcons[name] || serviceIcons.quality, { stroke: serviceStroke[name] || "#e11d3c" })}
  </span>
);

/* Pillar icons (why choose us) */
const pillarIcons = {
  expertise: (
    <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="9" cy="9" r="3" /><path d="M3.5 19a5.5 5.5 0 0 1 11 0" /><circle cx="17" cy="10" r="2.3" /><path d="M15 19a4.5 4.5 0 0 1 6.5-4" />
    </svg>
  ),
  standards: (
    <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="8.5" /><path d="M3.5 12h17" /><path d="M12 3.5c2.5 2.5 2.5 14 0 17M12 3.5c-2.5 2.5-2.5 14 0 17" />
    </svg>
  ),
  results: (
    <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="8.5" /><path d="M8.5 12l2.3 2.3L16 9" />
    </svg>
  ),
  capacity: (
    <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 19h16" /><path d="M4 19V9M9 19v-6M14 19v-9M19 19V5" /><path d="M4 9l5-3 5 4 5-5" />
    </svg>
  ),
  solutions: (
    <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9.5 16.5a5 5 0 1 1 5 0" /><path d="M9.5 16.5v2a1.5 1.5 0 0 0 1.5 1.5h2a1.5 1.5 0 0 0 1.5-1.5v-2" /><path d="M10 20.5h4" />
    </svg>
  ),
};

export const PillarIcon = ({ name }) => pillarIcons[name] || pillarIcons.results;

/* Generic UI icons */
export const IconCheck = (p) => (
  <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
    <circle cx="12" cy="12" r="9" strokeWidth="1.5" /><path d="M8.5 12l2.3 2.3L16 9" />
  </svg>
);
export const IconArrow = (p) => (
  <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" stroke="currentColor" {...p}>
    <path d="M5 12h14" /><path d="M13 6l6 6-6 6" />
  </svg>
);
export const IconGlobe = (p) => (
  <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
    <circle cx="12" cy="12" r="9" /><path d="M3 12h18" /><path d="M12 3c2.5 2.5 2.5 16 0 18M12 3c-2.5 2.5-2.5 16 0 18" />
  </svg>
);
export const IconPin = (p) => (
  <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
    <path d="M12 21c5-5 7-8 7-11a7 7 0 0 0-14 0c0 3 2 6 7 11z" /><circle cx="12" cy="10" r="2.5" />
  </svg>
);
export const IconMail = (p) => (
  <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
    <rect x="3" y="5" width="18" height="14" rx="2" /><path d="M3.5 6.5L12 12l8.5-5.5" />
  </svg>
);
export const IconPhone = (p) => (
  <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
    <path d="M5 4h3l1.5 4-2 1.5a11 11 0 0 0 5 5l1.5-2 4 1.5V18a2 2 0 0 1-2 2A15 15 0 0 1 3 6a2 2 0 0 1 2-2z" />
  </svg>
);
export const IconClock = (p) => (
  <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
    <circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" />
  </svg>
);
export const IconDownload = (p) => (
  <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" stroke="currentColor" {...p}>
    <path d="M12 4v11" /><path d="M8 11l4 4 4-4" /><path d="M5 20h14" />
  </svg>
);
export const IconDoc = (p) => (
  <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" {...p}>
    <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" /><path d="M14 3v5h5" /><path d="M9 13h6M9 17h6" />
  </svg>
);
export const IconNews = (p) => (
  <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" {...p}>
    <path d="M4 5h13v14H6a2 2 0 0 1-2-2z" /><path d="M17 8h3v9a2 2 0 0 1-2 2" /><path d="M7 9h7M7 13h7M7 17h5" />
  </svg>
);
export const IconHeart = (p) => (
  <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
    <path d="M3 12h4l2-5 4 10 2-5h6" />
  </svg>
);
export const IconLeaf = (p) => (
  <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
    <path d="M5 19c0-7 5-12 14-12 0 9-5 14-12 14a6 6 0 0 1-2-2z" /><path d="M9 15c2-2 4-3 6-3.5" />
  </svg>
);
export const IconPlus = (p) => (
  <svg viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" stroke="currentColor" {...p}>
    <path d="M12 5v14M5 12h14" />
  </svg>
);

/* Industry icons */
const industryIcons = {
  health: (
    <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 21c5-4 8-7.5 8-12a4.5 4.5 0 0 0-8-2.8A4.5 4.5 0 0 0 4 9c0 4.5 3 8 8 12z" /><path d="M8.5 11H11l1-2 1 3 1-1.5h1.5" />
    </svg>
  ),
  food: (
    <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 3v7a3 3 0 0 0 6 0V3" /><path d="M9 3v18" /><path d="M17 3c-1.5 0-2.5 2-2.5 5s1 4 2.5 4 2.5-1 2.5-4-1-5-2.5-5z" /><path d="M17 16v5" />
    </svg>
  ),
  energy: (
    <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M13 3L5 14h6l-1 7 8-11h-6l1-7z" />
    </svg>
  ),
  public: (
    <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 10l8-5 8 5" /><path d="M6 10v8M10 10v8M14 10v8M18 10v8" /><path d="M3 21h18" /><path d="M3 18h18" />
    </svg>
  ),
};
const industryStroke = { health: "#e11d3c", food: "#f7941d", energy: "#3b9ae1", public: "#c0185c" };
export const IndustryIcon = ({ name }) => (
  <span style={{ display: "inline-flex", color: industryStroke[name] || "#e11d3c" }}>
    {industryIcons[name]
      ? React.cloneElement(industryIcons[name], { stroke: industryStroke[name] || "#e11d3c" })
      : industryIcons.health}
  </span>
);
